<template>
         <div>
       <nav class="navbar navbar-default navbar-static-top fixed-top navbar-expand-lg navbar-dark bg-info bg-dark fixed-top">
    <div class="container">
      <router-link class="navbar-brand" to="/index" style="font-family:'KaiTi';text-shadow:0 0 10px #fff;font-size:20px;">华源医药</router-link>
      <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <!-- <div class="collapse navbar-collapse" id="navbarResponsive">
        <ul class="navbar-nav ml-auto" style="white-space:nowrap;">
          <li class="nav-item">
             <router-link class="nav-link" to="/storeQuery">库存查询(代理商)</router-link>
          </li>
           <li class="nav-item">
             <router-link class="nav-link" to="/saleQuery">销售查询(代理商)</router-link>
          </li>
          <li class="nav-item">
             <router-link class="nav-link" to="/goodsCheck">库存对账(代理商)</router-link>
          </li>
          <li class="nav-item">
             <router-link class="nav-link" to="/saleCheck">销售对账(代理商)</router-link>
          </li>
          <li class="nav-item">
             <router-link class="nav-link" to="/settlementQuery">结算查询(代理商)</router-link>
          </li>
          <li class="nav-item">
             <router-link class="nav-link" to="/NearlyGoods">近效期库存(代理商)</router-link>
          </li>
          <li class="nav-item">
             <router-link class="nav-link" to="/storeOverDue">超期占库费(代理商)</router-link>
          </li>
          <li class="nav-item">
             <router-link class="nav-link" to="/goodsForward">货物前移查询(代理商)</router-link>
          </li>
          <li class="nav-item">
             <router-link class="nav-link" to="/endregion">药品图片管理(代理商)</router-link>
          </li>
          <li class="nav-item">
             <router-link class="nav-link" to="/clerkinStore">入库记录(代理商)</router-link>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownBlog" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              其它
            </a>
            <div class="dropdown-menu dropdown-menu-right" style="font-size:1px" aria-labelledby="navbarDropdownBlog">
              <router-link class="dropdown-item text-center" to="">30天网上销售</router-link>
              <router-link class="dropdown-item text-center" to="/moreMessage">系统消息管理</router-link>
              <router-link class="dropdown-item text-center" to="/plan" v-if="groupid==26">新报计划</router-link>
              <router-link class="dropdown-item text-center" to="/drugQuery" v-if="groupid==26">药品查询</router-link>
              <router-link class="dropdown-item text-center" to="">开票信息</router-link>
            </div>
          </li>
          <li class="nav-item dropdown">
               <a href="#" class="nav-link dropdown-toggle" id="navbarDropdownBlog" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <img src="../../static/images/user.png" style="width:25px;height:25px;margin-top:-5px;" alt="">
               </a>
               <div class="dropdown-menu dropdown-menu-right" style="font-size:1px;" aria-labelledby="navbarDropdownBlog">
                   <a href="javascript:;" class="dropdown-item text-center">用户:
                      <span style="color:green;">{{username}}</span>
                      </a>
                  <router-link style="color:red;"  class="dropdown-item text-center" @click="clearLogin()" to="/">退出登录</router-link>
               </div>
          </li>
        </ul>
      </div> -->
       <div class="collapse navbar-collapse" id="navbarResponsive">
        <ul class="navbar-nav ml-auto" style="white-space:nowrap;">
           <li class="nav-item">
               <router-link class="nav-link" style="color:red;" to="" v-if="this.groupid==5">
                   (代理商)
               </router-link>
          </li>
           <li class="nav-item" v-if="this.groupid==26">
               <router-link class="nav-link" style="color:red;" to="">
                   (外销业务员)
               </router-link>    
          </li>
          <li class="nav-item" v-for="(item,index) in list" :key="index">
             <router-link class="nav-link" :to="item.role">{{item.name}}</router-link>
          </li>
          <li class="nav-item dropdown">
               <a href="#" class="nav-link dropdown-toggle" id="navbarDropdownBlog" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <img src="../../static/images/user.png" style="width:25px;height:25px;margin-top:-5px;" alt="">
               </a>
               <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownBlog">
                   <a href="javascript:;" class="dropdown-item text-left">用户:
                      <span style="color:green;">{{username}}</span>
                      </a>
                  <router-link class="dropdown-item text-left" to="/password">修改密码</router-link>
                  <router-link style="color:red;"  class="dropdown-item text-left" @click="clearLogin()" to="/">退出登录</router-link>
               </div>
          </li>
        </ul>
      </div>
    </div>
  </nav>
  
         </div>
</template>
<script>
export default {
     name:'m-header',
     data () {
       return {
            boss:"",
            username:"",
            groupid:'' ,
            list:[]     
       }
     },
     methods:{
        getBoss(){
           this.boss=window.sessionStorage.getItem("boss")
           this.username=window.sessionStorage.getItem("username")
           this.groupid=window.sessionStorage.getItem("groupid")
           
        },
        clearLogin(){
          window.sessionStorage.clear()
        },
        geList: async function(){
               const that=this
               const { data: res } = await this.$http.post('Dls/getQxList',{})
               // 
               that.list=res.data
        }
     },
     created(){
        this.getBoss()
        this.geList()
     }
}
</script>
<style scoped>
   
</style>



// WEBPACK FOOTER //
// src/components/Header.vue